// LOCAL COMPONENTS
import YearRange from './parts/YearRange';

// EXPORTS
export const MODEL_NAME_CODE_OPTIONS = [
  {
    label: 'Model Code',
    value: 1
  },
  {
    label: 'Model Name',
    value: 0
  }
]

export const MODEL_SELECTION_OPTIONS = [
  {
    label: 'All Models',
    value: 0
  },
  {
    label: 'Specific Models',
    value: 1
  }
]

export const TRIM_SELECTION_OPTIONS = [
  {
    label: 'All Trims',
    value: 0
  },
  {
    label: 'Specific Trims',
    value: 1
  }
]

export const YEARS_SELECTION_OPTIONS = [
  {
    label: 'All Years',
    value: 0
  },
  {
    label: 'Specific Year',
    value: 1,
    control: {
      name: 'year',
      schema: 'year'
    }
},
  {
    label: 'Range',
    value: 2,
    control: {
      as: YearRange
    }
  }
]
